import { toaster, Message } from "rsuite";

export const notify = (content: string, type: "info" | "success" | "warning" | "error" = "info", duration?: number) =>
    toaster.push(<Message type={ type } closable duration={duration ?? 3500}> { content } </Message>, { placement: "topEnd" });